import { useMutation } from "@tanstack/react-query";

import type { FeedbackDto } from "app/pages/sales-intelligence/modules/ai-agent/types/thread";
import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const useFeedbackMutation = ({ isEmail }: { isEmail: boolean }) => {
    return useMutation({
        mutationFn(dto: FeedbackDto) {
            if (isEmail) {
                return salesApiService.aiAgent.email.putAIAgentMessageFeedback(dto);
            }
            return salesApiService.aiAgent.meeting.putAIAgentMessageFeedback(dto);
        },
    });
};

export default useFeedbackMutation;
